// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discharge_titlebg_bus_trend {
    font-size: 1em;
    color: #0E3157;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: left;
    /* background: #E0E0E0; */
    border-radius: 5px 5px 0 0;
    margin-top: -8px;
    margin-left: 0px;
    margin-right: -15px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/TrendAnalysis_Bus/DischargeAnalysis/RangeAnalysis.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".discharge_titlebg_bus_trend {\n    font-size: 1em;\n    color: #0E3157;\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-align: left;\n    /* background: #E0E0E0; */\n    border-radius: 5px 5px 0 0;\n    margin-top: -8px;\n    margin-left: 0px;\n    margin-right: -15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
